// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mnC5","content":"styles_content__1aV3n","row":"styles_row__3a3ef","footer":"styles_footer__-cnc_","phraseLength":"styles_phraseLength__2woGa"};